


























import Vue, { PropOptions } from "vue";
import { Campaign, CampaignAudienceType } from "@/models";
import TabAudienceFile from "@/components/campaign/TabAudienceFile.vue";
import TabPhoneList from "@/components/campaign/TabPhoneList.vue";
import CampaignService from "@/services/CampaignService";

export default Vue.extend({
  components: { TabPhoneList, TabAudienceFile },
  props: {
    campaign: Object as PropOptions<Campaign>,
  },
  data() {
    return {
      tab: this.campaign.audienceType === CampaignAudienceType.List ? 1 : 0,
      items: ["Arquivo", "Lista de Telefones"],
    };
  },
  watch: {
    campaign(val) {
      const newTabValue =
        val.audienceType === CampaignAudienceType.List ? 1 : 0;
      if (newTabValue !== this.tab) {
        this.tab = newTabValue;
      }
    },
    tab(val) {
      if (val === 0) {
        const campaign = { ...this.campaign };
        const originalCampaign = this.$store.state.campaign.campaign;
        if (
          this.$route.name !== "campaignEdit" ||
          originalCampaign.audienceType === CampaignAudienceType.List
        ) {
          campaign.audienceFileTokenMapping =
            CampaignService.buildAudienceFileTokenMapping(campaign.textMessage);
          (campaign as any).audienceFile = null;
        }
        campaign.audienceType = CampaignAudienceType.File;
        this.$emit("update", campaign, this.tab);
      } else if (val === 1) {
        const campaign = { ...this.campaign };
        campaign.audienceType = CampaignAudienceType.List;
        this.$emit("update", campaign, this.tab);
      }
    },
  },
});
